import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

const onResponse = ({ ok, status }: Response) => ({
	success: ok,
	responseStatus: String(status),
});

export const experimentalGrantAccess: ExperimentalMutations['experimentalGrantAccess'] = (
	_,
	{ contentId, accessType, accountId },
	{ network: { BadStatusError, cfetch } },
) =>
	cfetch(`/wiki/rest/request-access/latest/page/restriction/${contentId}/grant/${accessType}`, {
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: accountId,
	}).then(
		/* onFulfilled */ onResponse,
		/* onRejected */ (reason) => {
			if (BadStatusError.isBadStatusError(reason)) {
				return onResponse(reason.response);
			}

			throw reason;
		},
	);
